import React, { useState, useEffect, useCallback, useRef } from "react";
import { initInstance, setPhone } from "../utils/segment";
import { eventTypes } from "../hooks/useTrack";
import message from "../utils/message";
import GET from "../utils/GET";
import useResource from "../hooks/useResource";
import { FETCH_USER_URL } from "../conf";
import uuid from "../utils/uuid";
import store from "../utils/store";
export const trackContext = React.createContext();

const isDesktopOverlay = GET("desktopOverlay");
const platform = GET("platform");
const full = GET("full");
const isModalWidget = GET("modal");

const inTestmode = GET("testmode");

const makeOptions = (publisher, fingerPrint) => ({
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    email: store.backedGET("email"),
    publisher,
    phone_number: store.backedGET("phone"),
    shipping_address_id: GET("shippingId"),
    billing_address_id: GET("billingId"),
    google_user_id: GET("guid"),
    fingerprint: fingerPrint,
  }),
  credentials: "include",
});

export default function Tracker({
  details: {
    sessionId = "",
    publisher = "",
    publisherName = "",
    url = "",
    categories = [],
    userName = "",
    postPurchase = false,
    survey = false,
    upsell = false,
    customerType = "",
    totalModules = -1,
  } = {},
  children,
  test = false,
}) {
  const [canTrack, setCanTrack] = useState(false);

  const lastProc = useRef(-1);

  const processEvent = useCallback(
    ({ name, properties = {} }, id) => {
      if (id <= lastProc.current || inTestmode) {
        return;
      }
      if (name === eventTypes.WIDGET_SMS_SEND) {
        setPhone(properties.value);
      }
      const allProperties = {
        coop_session: sessionId,
        publisher,
        publisher_name: publisherName,
        categories,
        userName,
        url,
        host: GET("host"),
        shipping_id: GET("shippingId"),
        billing_id: GET("billingId"),
        customer_id: GET("customerId"),
        created_at: GET("createdAt"),
        order_id: GET("identifier") || "",
        shopify_order_id: GET("shopifyOrderID") || "",
        post_purchase: postPurchase,
        survey,
        upsell,
        widget_version: 2,
        cost: GET("cost") || "",
        customer_type: customerType,
        total_modules: totalModules,
        coop_event_id: uuid(),
        ...properties,
      };

      window.analytics.track(name, allProperties);
      console.log("[ FIRED ] ", name);
      lastProc.current = id;
      return true;
    },
    [
      sessionId,
      publisher,
      publisherName,
      url,
      categories,
      postPurchase,
      survey,
      upsell,
      userName,
      customerType,
      totalModules,
    ]
  );

  const [userId, setUserId] = useState(null);

  const [{ data, error, loading }, load, , setOptions, reset] = useResource(
    FETCH_USER_URL,
    {},
    false
  );

  useEffect(() => {
    if (userId || loading || data || error) return;
    if (store.userId) {
      console.log(`[ Disco user ] Found local userId: ${store.userId}`);
      setUserId(store.userId);
      // return;
    }

    if (!window.FingerprintJS) {
      console.log(`[ Disco user ] FPJS not found.`);
      setOptions(makeOptions(publisher, null));
      load();
      return;
    }

    window.FingerprintJS.load()
      .then((fp) => fp.get())
      .then((result) => {
        console.log(`[ Disco user ] Using FP-JS for API call.`);
        setOptions(makeOptions(publisher, result.visitorId));
        load();
      })
      .catch(() => {
        console.log(`[ Disco user ] FP-JS failed.`);
        setOptions(makeOptions(publisher, null));
        load();
      });
  }, [userId, load, setOptions, data, loading, error, publisher]);

  useEffect(() => {
    if (!data && !error) return;
    if (data) {
      console.log(`[ Disco user ] User ID fetch success. Found:`, data.user_id);
      if (store.userId) {
        console.log(
          `[ Disco user ] Ignoring fetched userId, found local copy:`,
          store.userId
        );
        setUserId(store.userId);
      } else {
        store.userId = data.user_id;
        setUserId(data.user_id);
      }
    } else {
      const email = store.backedGET("email");
      const uid = email ? email : uuid();
      console.log(`[ Disco user ] User ID fetch failed, Using:`, uid);
      setUserId(uid);
    }
  }, [data, error, reset]);

  // Stores events while the Widget is not in view.
  const [queue, setQueue] = useState([]);

  const push = useCallback((event) => {
    setQueue((queue) => [...queue, event]);
  }, []);

  useEffect(() => {
    window.addEventListener("message", ({ data }) => {
      return data === "START" ? setCanTrack(true) : null;
    });
    message("READY");
  }, []);

  useEffect(() => {
    // TO FIX TEST
    if (test || !window?.analytics || !userId) {
      return;
    }
    initInstance(userId);
  }, [userId, test]);

  useEffect(() => {
    if (
      (canTrack || (postPurchase && !isModalWidget) || isDesktopOverlay) &&
      !!userId &&
      !platform &&
      !full &&
      queue.length > 0
    ) {
      queue.forEach(processEvent);
    }
  }, [canTrack, queue, processEvent, postPurchase, userId]);

  return <trackContext.Provider value={push}>{children}</trackContext.Provider>;
}

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { initInstance, setPhone } from "../utils/segment";
// import { eventTypes } from "../hooks/useTrack";
// import message from "../utils/message";
// import GET from "../utils/GET";
// export const trackContext = React.createContext();

// const isDesktopOverlay = GET("desktopOverlay");
// const platform = GET("platform");
// const full = GET("full");
// const isModalWidget = GET("modal");

// const inTestmode = GET("testmode");

// export default function Tracker({
// 	details: {
// 		userId,
// 		sessionId = "",
// 		publisher = "",
// 		publisherName = "",
// 		url = "",
// 		categories = [],
// 		userName = "",
// 		postPurchase = false,
// 		survey = false,
// 		upsell = false,
// 		customerType = "",
// 		totalModules = -1,
// 	} = {},
// 	children,
// 	test = false,
// }) {
// 	const [canTrack, setCanTrack] = useState(false);

// 	const lastProc = useRef(-1);

// 	const processEvent = useCallback(
// 		({ name, properties = {} }, id) => {
// 			if (id <= lastProc.current || inTestmode) {
// 				return;
// 			}
// 			if (name === eventTypes.WIDGET_SMS_SEND) {
// 				setPhone(properties.value);
// 			}
// 			const allProperties = {
// 				coop_session: sessionId,
// 				publisher,
// 				publisher_name: publisherName,
// 				categories,
// 				userName,
// 				url,
// 				host: GET("host"),
// 				shipping_id: GET("shippingId"),
// 				billing_id: GET("billingId"),
// 				customer_id: GET("customerId"),
// 				created_at: GET("createdAt"),
// 				order_id: GET("identifier") || "",
// 				shopify_order_id: GET("shopifyOrderID") || "",
// 				post_purchase: postPurchase,
// 				survey,
// 				upsell,
// 				widget_version: 2,
// 				cost: GET("cost") || "",
// 				customer_type: customerType,
// 				total_modules: totalModules,
// 				...properties,
// 			};
// 			window.analytics.track(name, allProperties);
// 			console.log("[ FIRED ] ", name);
// 			lastProc.current = id;
// 			return true;
// 		},
// 		[
// 			sessionId,
// 			publisher,
// 			publisherName,
// 			url,
// 			categories,
// 			postPurchase,
// 			survey,
// 			upsell,
// 			userName,
// 			customerType,
// 			totalModules,
// 		]
// 	);

// 	// Stores events while the Widget is not in view.
// 	const [queue, setQueue] = useState([]);

// 	const push = useCallback((event) => {
// 		setQueue((queue) => [...queue, event]);
// 	}, []);

// 	useEffect(() => {
// 		window.addEventListener("message", ({ data }) => {
// 			return data === "START" ? setCanTrack(true) : null;
// 		});
// 		message("READY");
// 	}, []);

// 	useEffect(() => {
// 		// TO FIX TEST
// 		if (test || !window?.analytics) {
// 			return;
// 		}
// 		if (!userId) {
// 			return;
// 		}
// 		initInstance(userId);
// 	}, [userId, test]);

// 	useEffect(() => {
// 		if (
// 			(canTrack ||
// 				(postPurchase && !isModalWidget) ||
// 				isDesktopOverlay) &&
// 			!platform &&
// 			!full &&
// 			queue.length > 0
// 		) {
// 			queue.forEach(processEvent);
// 		}
// 	}, [canTrack, queue, processEvent, postPurchase]);

// 	return (
// 		<trackContext.Provider value={push}>{children}</trackContext.Provider>
// 	);
// }

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { initInstance, setPhone } from "../utils/segment";
// import { eventTypes } from "../hooks/useTrack";
// import message from "../utils/message";
// import GET from "../utils/GET";
// export const trackContext = React.createContext();

// const isDesktopOverlay = GET("desktopOverlay");
// const platform = GET("platform");
// const full = GET("full");
// const isModalWidget = GET("modal");

// const inTestmode = GET("testmode");

// export default function Tracker({
// 	details: {
// 		userId,
// 		sessionId = "",
// 		publisher = "",
// 		publisherName = "",
// 		url = "",
// 		categories = [],
// 		userName = "",
// 		postPurchase = false,
// 		survey = false,
// 		upsell = false,
// 		customerType = "",
// 		totalModules = -1,
// 	} = {},
// 	children,
// 	test = false,
// }) {
// 	const [canTrack, setCanTrack] = useState(false);

// 	const lastProc = useRef(-1);

// 	const processEvent = useCallback(
// 		({ name, properties = {} }, id) => {
// 			if (id <= lastProc.current || inTestmode) {
// 				return;
// 			}
// 			if (name === eventTypes.WIDGET_SMS_SEND) {
// 				setPhone(properties.value);
// 			}
// 			const allProperties = {
// 				coop_session: sessionId,
// 				publisher,
// 				publisher_name: publisherName,
// 				categories,
// 				userName,
// 				url,
// 				host: GET("host"),
// 				shipping_id: GET("shippingId"),
// 				billing_id: GET("billingId"),
// 				customer_id: GET("customerId"),
// 				created_at: GET("createdAt"),
// 				order_id: GET("identifier") || "",
// 				shopify_order_id: GET("shopifyOrderID") || "",
// 				post_purchase: postPurchase,
// 				survey,
// 				upsell,
// 				widget_version: 2,
// 				cost: GET("cost") || "",
// 				customer_type: customerType,
// 				total_modules: totalModules,
// 				...properties,
// 			};
// 			window.analytics.track(name, allProperties);
// 			console.log("[ FIRED ] ", name);
// 			lastProc.current = id;
// 			return true;
// 		},
// 		[
// 			sessionId,
// 			publisher,
// 			publisherName,
// 			url,
// 			categories,
// 			postPurchase,
// 			survey,
// 			upsell,
// 			userName,
// 			customerType,
// 			totalModules,
// 		]
// 	);

// 	// Stores events while the Widget is not in view.
// 	const [queue, setQueue] = useState([]);

// 	const push = useCallback((event) => {
// 		setQueue((queue) => [...queue, event]);
// 	}, []);

// 	useEffect(() => {
// 		window.addEventListener("message", ({ data }) => {
// 			return data === "START" ? setCanTrack(true) : null;
// 		});
// 		message("READY");
// 	}, []);

// 	useEffect(() => {
// 		// TO FIX TEST
// 		if (test || !window?.analytics) {
// 			return;
// 		}
// 		if (!userId) {
// 			return;
// 		}
// 		initInstance(userId);
// 	}, [userId, test]);

// 	useEffect(() => {
// 		if (
// 			(canTrack ||
// 				(postPurchase && !isModalWidget) ||
// 				isDesktopOverlay) &&
// 			!platform &&
// 			!full &&
// 			queue.length > 0
// 		) {
// 			queue.forEach(processEvent);
// 		}
// 	}, [canTrack, queue, processEvent, postPurchase]);

// 	return (
// 		<trackContext.Provider value={push}>{children}</trackContext.Provider>
// 	);
// }
